/**
 * Configuración central de Google Maps. La clave web es pública por diseño
 * (va en el bundle); su seguridad depende de la restricción por referer en GCP.
 */

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? ''

/**
 * Map ID (mapa vectorial de GCP). Requerido por AdvancedMarker. Si no se
 * configura uno propio, usamos el DEMO de Google (funciona pero sin estilo
 * personalizado y con marca de agua de demostración).
 */
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID'

/** Hay clave configurada. Permite degradar elegantemente cuando falta. */
export const GOOGLE_MAPS_ENABLED = GOOGLE_MAPS_API_KEY.length > 0

/** Centro por defecto (Perú) y zoom de país, equivalentes al encuadre previo de Leaflet. */
export const PERU_CENTER: google.maps.LatLngLiteral = { lat: -9.19, lng: -75.0152 }
export const PERU_ZOOM = 5

/** Tipos de mapa usados en la app. `hybrid` = satélite + etiquetas. */
export type KMapType = 'roadmap' | 'satellite' | 'hybrid' | 'terrain'
